import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df0554b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "high-light" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_10 = { class: "operator-bar" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "产品名称"),
  /*#__PURE__*/_createElementVNode("div", null, "下单成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率")
], -1))
const _hoisted_14 = { class: "mark" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道销售排行", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "渠道"),
  /*#__PURE__*/_createElementVNode("div", null, "下单成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "下单成功率")
], -1))
const _hoisted_17 = { class: "mark" }
const _hoisted_18 = { class: "percentage" }
const _hoisted_19 = { class: "operator-bar" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "产品销售排行", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mark",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "产品名称"),
  /*#__PURE__*/_createElementVNode("div", null, "激活成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率")
], -1))
const _hoisted_23 = { class: "mark" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "渠道销售排行", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "渠道"),
  /*#__PURE__*/_createElementVNode("div", null, "激活成功量"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "激活成功率")
], -1))
const _hoisted_26 = { class: "mark" }
const _hoisted_27 = { class: "percentage" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  showLoadingToast,
  closeToast,
} from "vant";
import { formatPercentage } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'bjNumberCard',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const field = ref("orderSuccessCount");
const operatorOptions = [
  "全部",
  "北京移动",
  "北京电信",
  "江苏移动",
  "浙江移动",
];
const selectedOperator = ref("全部");
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序
// const orderPayRateAsc = ref(false); // 下单成功率升序
const distributorOrderPayCountAsc = ref(false); // 渠道-下单成功量升序

const visible = ref(true);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/bh/card/channel-total",
    method: "POST",
    data: {
      startDay: route?.params.time,
      endDay: route?.params.time,
      // groupUnit: sessionStorage.getItem("openid"),
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();
let time = dayjs(route.params.time as string).format("YYYY-MM-DD");
// 产品排行
const productsList = ref<any>([]);
const getProductsData = async () => {
  const operator =
    selectedOperator.value === "全部" ? undefined : selectedOperator.value;
  const res = await request({
    url: "/api/wx/bh/card/page-channel-product",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 1000,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        orderItem: {
          field: field.value,
          asc: productOrderPayCountAsc.value,
        },
        groupUnit: "product",
        ...(operator ? { operator } : {}),
        pidList: null,
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6a77l9SddB7PCU8-LNnbTtg',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    productsList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 渠道排行
const distributorLoading = ref(false);
const distributorList = ref<any>([]);
const getDistributorList = async () => {
  distributorLoading.value = true;
  const operator =
    selectedOperator.value === "全部" ? undefined : selectedOperator.value;
  const res = await request({
    url: "/api/wx/bh/card/page-channel-product",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 1000,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        orderItem: {
          field: field.value,
          asc: distributorOrderPayCountAsc.value,
        },
        groupUnit: "platform",
        ...(operator ? { operator } : {}),
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    distributorList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getDistributorList();

watch(productOrderPayCountAsc, () => {
  getProductsData();
});
watch(distributorOrderPayCountAsc, () => {
  getDistributorList();
});

const onOperatorChange = async (op: string) => {
  if (selectedOperator.value === op) return;
  selectedOperator.value = op;
  showLoadingToast({ message: "加载中...", forbidClick: true });
  try {
    await Promise.all([getProductsData(), getDistributorList()]);
  } finally {
    closeToast();
  }
};

const handleChange = (name: number) => {
  selectedOperator.value = "全部";
  if (name === 2) {
    field.value = "firstChargeCount";
  } else if (name === 1) {
    field.value = "activeCount";
  } else {
    field.value = "orderSuccessCount";
  }
  getProductsData();
  getDistributorList();
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, key, index) => {
          return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, " ·" + _toDisplayString(key), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (childRenItem, childRenIndex) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  title: childRenItem.name,
                  size: "large",
                  class: "bold",
                  "title-style": { width: '120px', flex: 'inherit' },
                  key: childRenIndex
                }, {
                  label: _withCtx(() => [
                    (childRenItem.name === '激活成功量')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "订单时间纬度"))
                      : _createCommentVNode("", true),
                    (childRenItem.name === '实际激活量')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "激活时间纬度"))
                      : _createCommentVNode("", true)
                  ]),
                  value: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(childRenItem.type === "percentage"
                    ? _unref(formatPercentage)(childRenItem.value)
                    : childRenItem.value) + "（环比：", 1),
                      _createElementVNode("span", {
                        style: _normalizeStyle({
                    color: childRenItem.percentage >= 0 ? 'red' : 'green',
                  })
                      }, _toDisplayString(`${
                      childRenItem.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(childRenItem.percentage)}`), 5),
                      _createTextVNode("） ")
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _hoisted_9,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          onChange: handleChange,
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "下单成功纬度" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorOptions, (op) => {
                    return _createElementVNode("span", {
                      key: op,
                      class: _normalizeClass(['operator-item', { active: selectedOperator.value === op }]),
                      onClick: ($event: any) => (onOperatorChange(op))
                    }, _toDisplayString(op), 11, _hoisted_11)
                  }), 64))
                ]),
                _hoisted_12,
                _hoisted_13,
                (!productsList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.productName || "- -"), 1),
                      _createElementVNode("div", null, _toDisplayString(item.orderSuccessCount), 1),
                      _createElementVNode("div", null, _toDisplayString(item.orderSuccessRate), 1)
                    ]))
                  }), 128))
                ]),
                _hoisted_15,
                _hoisted_16,
                (!distributorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      style: { borderBottom: '1px solid #ebedf0' },
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.platformName), 1),
                      _createElementVNode("div", null, _toDisplayString(item.orderSuccessCount), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.orderSuccessRate), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "激活成功纬度" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(operatorOptions, (op) => {
                    return _createElementVNode("span", {
                      key: op,
                      class: _normalizeClass(['operator-item', { active: selectedOperator.value === op }]),
                      onClick: ($event: any) => (onOperatorChange(op))
                    }, _toDisplayString(op), 11, _hoisted_20)
                  }), 64))
                ]),
                _hoisted_21,
                _hoisted_22,
                (!productsList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.productName || "- -"), 1),
                      _createElementVNode("div", null, _toDisplayString(item.activeCount), 1),
                      _createElementVNode("div", null, _toDisplayString(item.activeRate), 1)
                    ]))
                  }), 128))
                ]),
                _hoisted_24,
                _hoisted_25,
                (!distributorList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 1,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributorList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      style: { borderBottom: '1px solid #ebedf0' },
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.platformName), 1),
                      _createElementVNode("div", null, _toDisplayString(item.activeCount), 1),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(item.activeRate), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})